import React from "react";
import { Box, Text, Container } from "@chakra-ui/react";

function Footer() {
  return (
    <Box as="footer" bg="gray.800" py={8}>
      <Container maxW="container.xl">
        <Text textAlign="center" color="white">
          © {new Date().getFullYear()} Annie Salon. All Rights Reserved.
        </Text>
      </Container>
    </Box>
  );
}

export default Footer;
